import { render, staticRenderFns } from "./CreateSpecialOffer.vue?vue&type=template&id=188c8995"
import script from "./CreateSpecialOffer.vue?vue&type=script&lang=js"
export * from "./CreateSpecialOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports